var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content flex gap-2"},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_setup.computedIcon)}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }